angular.module('env.custom.customModule.approvalFields', [])

    .controller('approvalFieldsController', function ($log, $q, $scope, calendarService) {

        $scope.isRapid = function() {
            var returnOption = $scope.order.$model.jsonData.OrderData.OrthoticsOrder.ReturnOptions.Return;
            return returnOption && returnOption.toLowerCase().startsWith('rapid');
        }

        $scope.isInitial = function() {
            var orderType = $scope.order.$model.jsonData.OrderData.OrthoticsOrder.OrderType;
            return orderType && orderType.toLowerCase() === 'initial';
        }

        $scope.isWeightBearing = function() {
            var platform = $scope.order.$model.jsonData.OrderData.ApplicationOrderData.Platform;

            return platform && platform.toLowerCase() !== 'ios';
        }

        $scope.isOverdue = function () {
            if ($scope.orderItem.$model.expectedBy) {
                var now = new Date();
                now.setHours(0, 0, 0, 0);
                var completedDate = new Date($scope.orderItem.$model.expectedBy);
                completedDate.setHours(0, 0, 0, 0);

                return completedDate <= now;
            }
            return false;
        }
        $scope.isOverdueDelivery = function () {
            if ($scope.orderItem.$model.customFields.DeliveryDate) {
                var now = new Date();
                now.setHours(0, 0, 0, 0);
                var deliveryDate = new Date($scope.orderItem.$model.customFields.DeliveryDate);
                deliveryDate.setHours(0, 0, 0, 0);

                return deliveryDate <= now;
            }
            return false;
        }

        //var completionValidator = $("#completionDateForm").kendoValidator().data("kendoValidator");
        //var deliveryValidator = $("#deliveryDateForm").kendoValidator().data("kendoValidator");
        var publicHolidays = [];

        calendarService.getActualPublicHolidays('AU')
            .then(function (holidays) {
                    publicHolidays = holidays || [];

                    //Once we have holidays info, we can do other stuff we need to -
                    //Set default completion date to the currently selected item
                    //*** Commented out for now. We decided to not alter completion/delivery dates as they are all set by Scan Apps.
                    //$scope.$applyAsync(function () {
                    //    setDefaultCompletionDate($scope.orderItem);
                    //});

                    $scope.dpOptions = {
                        dates: [new Date("22/02/2019")],
                        disableDates: function (date) {
                            return isHoliday(date);
                        }
                    };
                },
                function (error) {
                    $log.error("Can't fetch public holidays information. Error: %s", error);
                    return $q.reject(error);
                });

        // We have decided to set the issue date from inside the ScanApp
        //
        //var watcherDestructor = $scope.$watch(
        //    'orderItem',
        //    function (newVal, oldVal) {
        //        if (newVal && newVal !== oldVal && (!newVal.$model.expectedBy || newVal.$model.expectedBy.getFullYear() === 1)) {
        //            setDefaultCompletionDate(newVal);
        //        }
        //    }
        //);
        $scope.$on('$destroy', function () {
            //watcherDestructor();
        });

        function isHoliday(date) {
            if (!date) {
                return false;
            }
            //See if it's weekend first
            if (date.getDay() === 0 || date.getDay() === 6) {
                return true;
            }

            //Then if it's a holiday
            for (var i = 0; i < publicHolidays.length; i++) {
                if (publicHolidays[i].getDate() === date.getDate() &&
                    publicHolidays[i].getMonth() === date.getMonth() &&
                    publicHolidays[i].getYear() === date.getYear()) {
                    return true;
                }
            }
            return false;
        }

        function setDefaultCompletionDate(orderItem) {
            if (orderItem) {
                //Set default completion date to be a number of working days ahead according to the order's 'returnOptions'
                var daysToAdd;
                switch (orderItem.$model.order.$model.jsonData.OrderData.OrthoticsOrder.ReturnOptions.Return) {
                    case "Rapid4Days":
                        daysToAdd = 4;
                        break;
                    case "Rapid72Hours":
                        daysToAdd = 3;
                        break;
                    case "Rapid48Hours":
                        daysToAdd = 2;
                        break;
                    case "Rapid24Hours":
                        daysToAdd = 1;
                        break;
                    case "RapidSameDay":
                        daysToAdd = 0;
                        break;
                    case "Unspecified":
                    case "Standard5Days":
                    default:
                        //5 - is the default work days number for Footlink. Later we will take holidays into account
                        daysToAdd = 5;
                        break;
                }
                //see how many days should we actually add to add required amount of working days skipping holidays
                var d = new Date(new Date().setHours(0, 0, 0, 0));
                var actualDaysToAdd = orderItem.$model.created.getHours() >= 14 ? daysToAdd : daysToAdd - 1;
                if (isHoliday(d)) { //we add one more day if it's a holiday today exactly
                    actualDaysToAdd++;
                }
                for (var i = 0; i < actualDaysToAdd; ++i) {
                    d = new Date(d.getTime() + 1000 * 60 * 60 * 24); //add one day
                    if (isHoliday(d)) { //we need more if it's a holiday
                        actualDaysToAdd++;
                    }
                }
                var todayMidnight = new Date(new Date().setHours(0, 0, 0, 0));
                orderItem.$model.expectedBy = new Date(todayMidnight.getTime() + 1000 * 60 * 60 * 24 * actualDaysToAdd);
            }
        }
    });
